import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { fabric } from "fabric";
import axios from "axios";
import { saveFullMockup, getFullMockup } from "../../store/actions/mockups";

// Render mockup large
const MockupView = () => {
  const dispatch = useDispatch();
  const mockupSelected = useSelector(({ image }) => image.mockupSelected);
  const exportReady = useSelector(({ app }) => app.exportReady);
  const savedMockup = useSelector(({ image }) => {
    let mock = image.fullMockupsList.find((f) => f.mockupsNr === mockupSelected.mockupsNr);
    if (mock && mock.base64) {
      return mock.base64;
    } else {
      return null;
    }
  });
  useEffect(async () => {
    if (exportReady === false || !mockupSelected || savedMockup) {
      return;
    }
    dispatch(getFullMockup());
  }, [mockupSelected, exportReady]);

  return (
    <div className="mm-pod-section-auto p-2 text-center">
      {!!mockupSelected && (
        <img
          src={
            savedMockup
              ? savedMockup
              : "https://mediamodifier.com/gfx/loader.png"
          }
          alt=""
          style={{
            height: "auto",
            width: "auto",
            maxWidth: "100%",
            maxHeight: "100%",
          }}
        />
      )}
    </div>
  );
};

export default MockupView;
